import Icon from '../components/Icon.vue'

Icon.register({"crop":{"width":512,"height":512,"paths":[{"d":"M488 352H448V109.3L505 52.3C514.4 42.9 514.4 27.7 505 18.4L493.7 7C484.3-2.4 469.1-2.4 459.8 7L402.8 64H160V24C160 10.7 149.3 0 136 0H88C74.7 0 64 10.7 64 24V64H24C10.7 64 0 74.7 0 88V136C0 149.3 10.7 160 24 160H64V424C64 437.3 74.7 448 88 448H352V488C352 501.3 362.7 512 376 512H424C437.3 512 448 501.3 448 488V448H488C501.3 448 512 437.3 512 424V376C512 362.7 501.3 352 488 352zM306.7 160L160 306.7V160H306.7zM205.3 352L352 205.3V352H205.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/crop.js
// module id = null
// module chunks = 